import { render, staticRenderFns } from "./propertyDeductionRebateConfig.vue?vue&type=template&id=547f2564&scoped=true"
import script from "./propertyDeductionRebateConfig.vue?vue&type=script&lang=js"
export * from "./propertyDeductionRebateConfig.vue?vue&type=script&lang=js"
import style0 from "./propertyDeductionRebateConfig.vue?vue&type=style&index=0&id=547f2564&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547f2564",
  null
  
)

export default component.exports